import { es_US } from '@docupet/component-library';

export default {
  ...es_US,
  cancelRegistration: 'Cancelar Registro',
  errorMessages: {
    duplicatePetCancelRegistration:
      'Si desea utilizar el correo electrónico proporcionado para su registro existente, cancele este registro ahora. Tenga en cuenta que si continúa con la cancelación de este registro que inició, se eliminará de forma permanente.',
  },
};
